import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
const attempts = [{
  title: 'Contar calorías',
  description: 'Solo estresa más a tu cuerpo, aumentando el cortisol y la retención de líquidos.'
}, {
  title: 'Dietas Detox de 3 días',
  description: 'Eliminan agua temporalmente, pero no sanan la barrera intestinal que causa el problema.'
}, {
  title: 'Matarte en el gimnasio',
  description: 'El ejercicio de alta intensidad en un cuerpo inflamado es como echarle gasolina a un incendio.'
}, {
  title: 'Productos "Light" o Integrales',
  description: 'Muchos están cargados de aceites vegetales y edulcorantes que irritan tu microbiota aún más.'
}];
export function FailedAttempts() {
  return <section className="py-10 md:py-28 bg-cream-200" data-id="element-19">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-20">
        <FadeIn data-id="element-21">
          <div className="text-center mb-16" data-id="element-22">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-4" data-id="element-23">
              Por qué lo que intentaste no funcionó
            </h2>
            <p className="text-lg text-charcoal-light max-w-2xl mx-auto font-sans" data-id="element-24">
              No es tu culpa. La industria del fitness nos ha enseñado a luchar
              contra nuestro cuerpo en lugar de sanarlo.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-25">
          {attempts.map((attempt, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
              <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 h-full border border-cream-300" data-id="element-27">
                <div className="flex items-start gap-4" data-id="element-28">
                  <div className="flex-shrink-0 mt-1" data-id="element-29">
                    <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-30">
                      <X className="w-5 h-5 text-coral-500" strokeWidth={3} data-id="element-31" />
                    </div>
                  </div>
                  <div data-id="element-32">
                    <h3 className="text-xl font-bold text-charcoal mb-2 font-sans" data-id="element-33">
                      {attempt.title}
                    </h3>
                    <p className="text-charcoal-light leading-relaxed" data-id="element-34">
                      {attempt.description}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}